var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SyfLoader } from 'syf-component-library/ui/atoms';
import postTransactionEligible from '../../redux/transactionEligible/postTransactionEligible';
import { DisputeFeature } from '../../typings';
import { openModal } from '../../redux/ui/ui.slice';
import { ModalType } from '../../redux/ui/typings';
import { DisputeStatus, EligibilityWrapper, LoadingWrapper, NonEligibleForDispute, TransactionEligibilityError } from './subcomponents';
import { STATUS } from './helpers';
var DISPUTE_SUBMISSION_PENDING_ERROR_CODE = '600015';
var TransactionEligible = function () {
    var _a = useSelector(function (_a) {
        var appConfig = _a.appConfig, mfeConfig = _a.mfeConfig;
        return ({
            appConfig: appConfig,
            mfeConfig: mfeConfig
        });
    }), _b = _a.appConfig, accountId = _b.accountId, operationId = _b.operationId, returnToParent = _b.returnToParent, apigeeURL = _a.mfeConfig.apigeeURL;
    var _c = useSelector(function (_a) {
        var transactionData = _a.transactionData;
        return transactionData;
    }), referenceNumber = _c.referenceNumber, statementDate = _c.statementDate, transactionAmount = _c.transactionAmount, transactionCode = _c.transactionCode, transactionDate = _c.transactionDate, transactionId = _c.transactionId;
    var isLoading = useSelector(function (_a) {
        var ui = _a.ui;
        return ui;
    }).isLoading;
    var _d = useSelector(function (_a) {
        var transactionEligible = _a.transactionEligible;
        return transactionEligible;
    }), caseId = _d.caseId, eligible = _d.eligible, caseStatus = _d.caseStatus, caseStatusDescription = _d.caseStatusDescription, error = _d.error, isCancelSubmitted = _d.isCancelSubmitted;
    var _e = useState(false), clicked = _e[0], setClicked = _e[1];
    var dispatch = useDispatch();
    var navigateToDispute = function (featureType, modalType) {
        if (featureType === DisputeFeature.Questionnaire) {
            returnToParent(featureType);
            dispatch(openModal(ModalType.Questionnaire));
        }
        else {
            var disputeDetail = {
                modalType: modalType,
                caseId: caseId,
                transactionId: transactionId
            };
            returnToParent(featureType, disputeDetail);
        }
    };
    var handleTransactionEligible = function () {
        setClicked(true);
        dispatch(postTransactionEligible({
            accountId: accountId,
            apiHost: apigeeURL,
            operationId: operationId,
            referenceNumber: referenceNumber,
            statementDate: statementDate,
            transactionCode: transactionCode,
            transactionDate: transactionDate,
            transactionAmount: transactionAmount,
            transactionId: transactionId
        }));
    };
    var renderEligibilityState = function () {
        var _a, _b;
        if (isLoading) {
            return (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) }));
        }
        if (error === null || error === void 0 ? void 0 : error.code) {
            return _jsx(TransactionEligibilityError, {});
        }
        if (caseStatus) {
            return (_jsx(DisputeStatus, { caseStatus: caseStatus, caseStatusDescription: caseStatusDescription, navigateToDispute: navigateToDispute, isCancelSubmitted: isCancelSubmitted }));
        }
        if (((_b = (_a = error === null || error === void 0 ? void 0 : error.businessErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) === DISPUTE_SUBMISSION_PENDING_ERROR_CODE) {
            return (_jsx(DisputeStatus, { caseStatus: STATUS.CLAIM_OPENED_PENDING, caseStatusDescription: caseStatusDescription, navigateToDispute: function () { }, isCancelSubmitted: false }));
        }
        return _jsx(NonEligibleForDispute, {});
    };
    useEffect(function () {
        if (eligible) {
            returnToParent(DisputeFeature.Questionnaire);
            dispatch(openModal(ModalType.Questionnaire));
        }
    }, [dispatch, eligible, returnToParent]);
    return (_jsx(EligibilityWrapper, __assign({ "data-test-automation-eligibility-status": true }, { children: !clicked ? (_jsx(NonEligibleForDispute, { onClick: handleTransactionEligible })) : (renderEligibilityState()) })));
};
export default TransactionEligible;
//# sourceMappingURL=index.js.map